"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof3 = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _react = _interopRequireWildcard(require("react"));
var _Title = _interopRequireDefault(require("../../Title"));
var _Modal = _interopRequireDefault(require("./../../Modal"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof3(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
// Property 'status' does not exist on type '[boolean, Dispatch<SetStateAction<boolean>>]
// interface li_config {
//   richBtnTxt?: string;
//   richTextContent?: string;
// }
function A_component(props) {
  var _a = props || {},
    txt = _a.txt,
    href = _a.href,
    extendProps = _a.extendProps;
  return /*#__PURE__*/_react["default"].createElement("li", {
    className: 'flex-free-with-credit__container__ul__li'
  }, /*#__PURE__*/_react["default"].createElement("a", __assign({}, extendProps || {}, {
    href: href,
    className: 'flex-free-with-credit__container__ul__li__a'
  }), txt));
}
function Li_component(props) {
  var _a = props || {},
    txt = _a.txt,
    handle = _a.handle,
    modalTitle = _a.modalTitle,
    setModalList = _a.setModalList,
    list = _a.list,
    setModalContent = _a.setModalContent,
    richTextContent = _a.richTextContent,
    extendProps = _a.extendProps;
  return /*#__PURE__*/_react["default"].createElement("li", __assign({}, extendProps || {}, {
    className: 'flex-free-with-credit__container__ul__li',
    onClick: function onClick() {
      if (handle) {
        handle(true);
        setModalList({
          list: list,
          modalTitle: modalTitle
        });
        // console.log('list',list)
        // console.log('modalTitle',modalTitle)
        setModalContent(richTextContent);
      }
    }
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: 'flex-free-with-credit__container__ul__li__span'
  }, txt));
}
function FreeWithCredit(props) {
  var flexTitle = props.flexTitle,
    style = props.style,
    configuration = props.configuration;
  var _a = configuration || {},
    list = _a.list,
    description = _a.description;
  var _b = (0, _react.useState)(false),
    status = _b[0],
    setStatus = _b[1];
  var _c = (0, _react.useState)({}),
    modalList = _c[0],
    setModalList = _c[1];
  var _d = (0, _react.useState)(''),
    modalContent = _d[0],
    setModalContent = _d[1];
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: 'flex-free-with-credit',
    style: (0, _typeof2["default"])(style) === 'object' ? style : {}
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'flex-free-with-credit__children'
  }, /*#__PURE__*/_react["default"].createElement(_Title["default"], {
    style: {
      paddingBottom: '12px',
      maxWidth: '1440px'
    },
    title: flexTitle
  }), /*#__PURE__*/_react["default"].createElement("section", {
    className: 'flex-free-with-credit__container'
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: 'flex-free-with-credit__container__span'
  }, description), /*#__PURE__*/_react["default"].createElement("ul", {
    className: 'flex-free-with-credit__container__ul'
  }, list && list.map(function (item, index) {
    var _a = item || {},
      txt = _a.txt,
      type = _a.type,
      href = _a.href,
      modalTitle = _a.modalTitle,
      richBtnTxt = _a.richBtnTxt,
      richTextContent = _a.richTextContent,
      extendProps = _a.extendProps;
    switch (type) {
      case 'a':
        return /*#__PURE__*/_react["default"].createElement(A_component, {
          txt: txt,
          href: href,
          key: index,
          extendProps: extendProps
        });
      default:
        return /*#__PURE__*/_react["default"].createElement(Li_component, {
          key: index,
          txt: txt,
          handle: setStatus,
          setModalList: setModalList,
          setModalContent: setModalContent,
          richTextContent: richTextContent,
          list: richBtnTxt,
          modalTitle: modalTitle,
          extendProps: extendProps
        });
    }
  }))), status && ( /*#__PURE__*/_react["default"].createElement(_Modal["default"], {
    close: function close() {
      setStatus(false);
    },
    submit: function submit() {
      setStatus(false);
    },
    modalList: modalList,
    modalContent: modalContent
  }))));
}
FreeWithCredit.displayName = 'TCIThumbnail';
var _default = exports["default"] = FreeWithCredit;